import React, { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
type GlowFrameProps<T extends ElementType> = {
  as?: T;
  interactive?: boolean;
  className?: string;
  children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'className' | 'children'>;
export function GlowFrame<T extends ElementType = 'div'>({
  as,
  interactive = false,
  className = '',
  children,
  ...rest
}: GlowFrameProps<T>) {
  const Component = (as || 'div') as ElementType;
  return <Component className={['border border-led/70 shadow-[0_0_0_1px_rgba(242,247,255,0.12),0_0_18px_-6px_rgba(143,211,240,0.4)] transition-shadow duration-300 ease-out', interactive ? 'hover:border-led hover:shadow-[0_0_0_1px_rgba(242,247,255,0.6),0_0_36px_-4px_rgba(143,211,240,0.7)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice focus-visible:ring-offset-2 focus-visible:ring-offset-ink' : '', className].filter(Boolean).join(' ')} {...rest} data-id="element-132" data-mp="13vw2a3k6x50e">
      {children}
    </Component>;
}